import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'jotai';
import SharePage from './pages/share';
import { NotFoundPage } from '@higgins/ui';
import Layout from './pages/_layout';

export default function App() {
  return (
    <Provider>
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<SharePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Router>
    </Provider>
  );
}
